<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formCloseConcurrence">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="concurrenceCode" [labelText]="'Proceso'" [list]="listConcurrences"
                [required]="true" [recovery]="true">
              </app-custom-select>
            </div>

            <div class="col-lg-2 col-md-4 col-sm-6 col-12 my-2 my-lg-0 d-flex align-items-end gap-1">
              <app-custom-button [title]="'Información'" [severity]="'secondary'" [icon]="'pi pi-info-circle'"
                (onClick)="openToggle($event)"></app-custom-button>
              <p-popover #information>
                <div>
                  <span>
                    <b>Prefacturación: </b>Se desbloquea cuando a la hora de darle click
                    <br> a prefacturar en algún corte sale un mensaje de error que dice "Error.
                    <br> No pude procesar. Otro usuario está procesando en este momento."
                    <br><br>
                    <b>Facturación: </b>Se desbloquea cuando a la hora de darle click a facturar
                    <br>en algún corte sale un mensaje de error que dice "Error. No pude procesar.
                    <br>Otro usuario está procesando en este momento."
                    <br><br>
                    <b>Ocupación: </b>Se desbloquea cuando a la hora de consultar el informe
                    <br>de porcentaje de ocupación sale un mensaje de error que dice "Error.
                    <br>No pude procesar. Otro usuario está procesando en este momento."
                    <br><br>
                    <b>Desbloquear Corte: </b>Desbloquea todos los cortes de la sucursal que
                    <br>se encuentren bloqueados por cualquier usuario.
                  </span>
                </div>
              </p-popover>
              <app-custom-button [label]="'Desbloquear'" [severity]="'primary'" [disabled]="!permissionUpdatable"
                [variant]="undefined" (onClick)="closeConcurrence()" [width]="'5.5rem'"></app-custom-button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>